import { render, staticRenderFns } from "./MDT.vue?vue&type=template&id=4481f70c&"
import script from "./MDT.vue?vue&type=script&lang=ts&"
export * from "./MDT.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4481f70c')) {
      api.createRecord('4481f70c', component.options)
    } else {
      api.reload('4481f70c', component.options)
    }
    module.hot.accept("./MDT.vue?vue&type=template&id=4481f70c&", function () {
      api.rerender('4481f70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/MDT.vue"
export default component.exports